import { FiStar } from '@/components/react-icons/main';
import IconV2 from '@/components/v2/IconV2';
import selectors from '@/redux/selectors/selectors';
import utilityAppIcons from '@/screens/workflows/schema/utilityAppIcons';
import { formatAttributeKey } from '@shared/workflow/formatAttributeKey.js';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

// Display-only version of a variable block. Does not use Redux/store.
const BlockViewerComponent = memo(({ data }) => {
  const appIcon = data?.appId ? useSelector((state) => selectors.appById(state, data?.appId)?.icon) : null;
  const appSlug = data?.appId ? useSelector((state) => selectors.appById(state, data?.appId)?.slug) : null;
  const title = useMemo(() => formatAttributeKey(data?.key), [data?.key]);

  return (
    <div className={'lexical-block'} data-title={title}>
      <span className={'label'}>{`${data?.stepNumber || ''} ${formatAttributeKey(data?.key)}`.trim()}</span>
      {data?.map && <div className={'label map'}>{`MAP`}</div>}
      <IconV2 icon={appIcon || utilityAppIcons[appSlug || data.id] || FiStar} />
    </div>
  );
});

BlockViewerComponent.displayName = 'BlockViewerComponent';

export default BlockViewerComponent;
